import React from 'react';
import {CheckCircleFill, XCircleFill} from "react-bootstrap-icons";

const CardPlaceholder = (props) => {
    const size = 32;
    const style = {marginTop: 100, marginLeft: -16};
    const validColor = '#0C7800';
    const invalidColor = '#BE3434';

    return <>
        <img src={props.src} alt={props.alt}/>
        {props.isValid ?
            <CheckCircleFill style={style} size={size} color={validColor}/> :
            <XCircleFill style={style} size={size} color={invalidColor}/>
        }

    </>
}

export default CardPlaceholder;